import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { useEffect, useState } from 'react'
import { apiGet } from '~/util/api'
import { useTranslation } from '~/hooks/useTranslation'

const useCareerSearchForm = ({
  compare,
  sampleTitles,
  occupation,
  reportedTitle,
}) => {
  const [submitted, setSubmitted] = useState(false)
  const [buttonStatus, setButtonStatus] = useState('save')

  const [whatDropdownItems, setWhatDropdownItems] = useState(sampleTitles)
  const [what2DropdownItems, setWhat2DropdownItems] = useState(sampleTitles)

  const { t } = useTranslation('CareerSearchForm')
  const message = t('select_from_dropdown')

  const secondSearchTerm = compare
    ? { what2: z.enum(what2DropdownItems, { message }) }
    : {}

  const schema = {
    what: z.enum(whatDropdownItems, { message }),
    ...secondSearchTerm,
    type: z.string(),
  }

  const defaultValues = {
    what: reportedTitle?.reported_job_title || occupation?.title || '',
    what2: '',
    type: 'exact',
  }

  const form = useForm({
    resolver: zodResolver(z.object(schema)),
    defaultValues,
  })

  const { watch } = form

  const whatTerm = watch('what')
  const what2Term = watch('what2')

  useEffect(() => {
    setWhatDropdownItems(sampleTitles.filter((item) => item !== what2Term))
  }, [what2Term, sampleTitles])

  useEffect(() => {
    setWhat2DropdownItems(sampleTitles.filter((item) => item !== whatTerm))
  }, [whatTerm, sampleTitles])

  const onSubmit = (values) => {
    setSubmitted(true)
    setButtonStatus('saving')
    if (compare) {
      compareRoles(values)
    } else search(values)
  }

  const compareRoles = async (values) => {
    const item1 = await getItem(values.what)
    const item2 = await getItem(values.what2)
    if (item1 && item2) {
      setSubmitted(false)
      window.location.href = `/career_exploration/search/compare?onetsoc_code1=${item1.onetsoc_code}&reported_title_id=${item1.id}&onetsoc_code2=${item2.onetsoc_code}&reported_title_id2=${item2.id}`
    }
  }

  const getItem = async (what) => {
    const url = `/career_exploration/search/results_json?term=${what}&type="exact`
    let response
    try {
      response = await apiGet(url)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
    if (response.status === 200) {
      const responseData = response.data
      const firstItem = responseData.entries[0]
      return firstItem
    } else {
      throw new Error('Error fetching data')
    }
  }

  const search = async (values) => {
    const item = await getItem(values.what)
    if (item) {
      setSubmitted(false)
      window.location.href = `/career_exploration/search?onetsoc_code=${item.onetsoc_code}&reported_title_id=${item.id}`
    }
  }

  return {
    form,
    onSubmit,
    submitted,
    buttonStatus,
  }
}

export default useCareerSearchForm
